import React from "react";
import "./index.scss";
import Text from "features/components/text";
import Title from "features/components/title";
import {array} from "prop-types";
import {Icon} from "features/components/icon";

export const SpeakerBox = (props) => {
    const {speakers} = props;
    return <div className="speakers-box">
        {speakers.map(i => <div key={i.name} className="speaker">
            {!!i.avatar ? <img src={i.avatar} alt="speaker avatar"/> : <div className="default"><Icon>account-circle</Icon></div>}
            <div className="name">
                <Text size={14}>{i.title}</Text>
                <Title size={18}>{i.name}</Title>
            </div>
        </div>)}
    </div>
}
SpeakerBox.propTypes = {
    speakers: array
};